import axios from "axios";
import { appConfig } from "../constants/config/appConfig";
import { toastService } from "../component/common/toast-messages/toast";
import { BASE_URL } from "../constants";
import { Navigate } from "react-router-dom";
import i18next from "i18next";
// Add a request interceptor

const axiosInstance = axios.create({
  baseURL:
    window.location.hostname === "localhost"
      ? BASE_URL
      : `${window.location.protocol}//${window.location.host}/api/`,
});

/* Add a request interceptor */
const requestInterceptor = (config) => {
  if (localStorage.getItem(appConfig.SESSION_USER_TOKEN)) {
    config.headers["Authorization"] = localStorage.getItem(
      appConfig.SESSION_USER_TOKEN
    );
  }
  return config;
};

const errorReqInterceptor = (error) => {
  toastService.error(error?.message);
};

axiosInstance.interceptors.request.use(requestInterceptor, errorReqInterceptor);
/* Add a request interceptor */

/* Add a response interceptor */
const responseInterceptor = (response) => {
  return response?.data?.data ?? response?.data;
};

const errorResInterceptor = (error) => {
  if (error.response && error.response.status === 401) {
    if (error.response?.request?.responseURL?.includes("set-new-password")) {
      toastService.error(i18next.t("CommonUtils.SetNewPasswordMessage"));
      setTimeout(() => {
        localStorage.clear();
        window.location.replace("/")
      }, 5000);
    } else {
      toastService.error("Session Expired");
      localStorage.clear();
      window.location.reload();
      window.location.href = "/web-app/login"
    }
  } else if (error.response && error.response.status === 504) {
    toastService.error("Request Failed!");
    return null;
  } else {
    if (
      error?.response?.data?.statusCode === 422 &&
      Object.keys(error?.response?.data?.errors).length > 0
    ) {
      Object.keys(error?.response?.data?.errors).map((element) => {
        const errorMsg = error?.response?.data?.errors[element];
        toastService.error(errorMsg);
      });
    } else {
      let message = error?.response?.data?.message ?? error?.message;
      toastService.error(message);
    }
    return null;
  }
};

axiosInstance.interceptors.response.use(
  responseInterceptor,
  errorResInterceptor
);
/* Add a response interceptor */

export { axiosInstance };
